import { MultiIdCombobox } from '@/components/ui/multi-id-combobox';
import { useAorText } from 'utils/aorTerminology';

export type IncidentsFilterBarProps = {
  typeOptions: { value: string; label: string }[];
  selectedTypes: string[];
  onTypesChange: (types: string[]) => void;
  aorOptions: { value: string; label: string }[];
  selectedAorIds: string[];
  onAorIdsChange: (ids: string[]) => void;
};

export function IncidentsFilterBar({
  typeOptions,
  selectedTypes,
  onTypesChange,
  aorOptions,
  selectedAorIds,
  onAorIdsChange,
}: IncidentsFilterBarProps) {
  const aorText = useAorText();
  return (
    <div className="tw:space-y-2">
      <div className="tw:flex tw:min-w-0 tw:flex-col tw:gap-1">
        <span className="tw:text-xs tw:text-muted-foreground">Category</span>
        <MultiIdCombobox
          options={typeOptions}
          value={selectedTypes}
          onChange={onTypesChange}
          placeholder="All categories"
        />
      </div>
      <div className="tw:flex tw:min-w-0 tw:flex-col tw:gap-1">
        <span className="tw:text-xs tw:text-muted-foreground">
          {aorText('AOR')}
        </span>
        <MultiIdCombobox
          options={aorOptions}
          value={selectedAorIds}
          onChange={onAorIdsChange}
          placeholder={aorText('All AORs')}
        />
      </div>
    </div>
  );
}
